/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';

import DS from 'ember-data';
import BackfillModel from 'cio/models/backfill';

interface TaskListArgs {
  backfills: DS.RecordArray<BackfillModel>;
  selectCallback: () => unknown;
}

export default class TaskList extends Component<TaskListArgs> {}
